import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { MdOutlineClose } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
const recaptchaRef = React.createRef();
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import accessStyle from "./styles";
import { Box, Typography, Link, Modal, List, ListItem, Button } from "@mui/material";
import SocialShareComponent from "../Buttons/socialShareReferral";
import {
  RECAPTCHA_SITE_KEY,
  GEOLOCATION_URL,
  WEB_URL,
  API_BASE_URL,
  DISCORD_URL,
} from "../../src/constant/appConstants";

const styles = {
  headingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "34px",
    color: "black",
    textTransform: "capitalize",
  },
  dataContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "582px",
    margin: "auto",
    textAlign: "center",
    color: "#fff",
  },
  descriptionText: {
    fontFamily: "Inter",
    fontstyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center",
    fontFeatureSettings: "'cpsp' on",
    color: "rgba(0, 0, 0, 0.75)",
  },
  offerText: {
    margin: "auto",
    marginLeft: "8px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#000000",
  },
  offerTextBox: {
    width: "130px",
    height: "36px",
    position: "relative",
    marginLeft: "8px",
  },
  offerIconBox: {
    position: "relative",
    background: "rgba(0, 0, 0, 0.9)",
    border: "1px solid #E1CAF2",
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    margin: "0px",
    padding: "0px",
    float: "left",
  },
  offerIcon: {
    width: "24px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "12px 0px 0px 6px",
  },
  offerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  signupError: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "21px",
    color: "red",
    marginTop: "15px",
  },
  rankContainer: {
    overflow: "hidden",
    position: "relative",
    width: "160px",
    height: "160px",
    margin: "30px auto 0px",
    borderRadius: "80px",
    borderWidth: "3px",
    borderColor: "red",
    background: "linear-gradient(to right, #E14084, #3454FA , #54B5BB)",
  },
  rankContainerInside: {
    width: "154px",
    height: "154px",
    background: "#fff",
    borderRadius: "79px",
    margin: "3px 0px 0px 3px",
  },
  rankHeadingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    linHeight: "19px",
    margin: "45px 0px 0px 0px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
  },
  modalCloseButton: {
    cursor: "pointer",
    position: "relative",
    float: "right",
  },
  rankText: {
    position: "relative",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "36px",
    linHeight: "44px",
    margin: "0px 0px 0px 32px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
    textAlign: "center",
    background: "yellow",
    textTransform: "uppercase",
    background:
      "-webkit-linear-gradient(45deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  waitListDescription: {
    width: "100%",
    maxWidth: "671px",
    position: "relative",
    margin: "20px auto 0px",
  },
  waitListText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "27px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  urlContainer: {
    padding: "2px 10px",
    maxWidth: "500px",
    height: "36px",
    border: "1px dashed rgba(0, 0, 0, 0.9)",
    borderRadius: "10px",
    position: "relative",
    margin: "24px auto 0",
    display: "flex",
    alignItems: "center",
  },
  bottomLink: {
    color: "#E14084",
    display: "block",
    marginTop: "10px",
    textAlign: "center",
  },
  urlText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  copyToClipboardContainer: {
    width: "45px",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
    marginLeft: "10px",
  },
  copyToClipboardButton: {
    cursor: "pointer",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
  },
  copied: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
  },
  socialButtonsContainer: {
    position: "relative",
    margin: "0 auto",
    display: "block",
    textAlign: "center",
  },
  dashline: {
    width: "449px",
    margin: "28px auto 19px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  bottomText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "21px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  offerContainerBox: {
    position: "realtive",
    width: "703px",
    height: "101px",
    margin: "30px 0px 0px 54px",
    background: "url('/images/icons/bgEarlyAccessOffer.png')",
    borderRadius: "10px",
    color: "white",
    p: 4,
    padding: "0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
  },
  earlyAccessBox: {
    width: "176.78px",
    height: "172px",
    background: "linear-gradient(92deg, #626FD3 -6.99%, #8729BA 123.11%)",
    marginLeft: "-62px",
    borderRadius: "86px",
    overflow: "hidden",
  },
  earlyAccessText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "22px",
    margin: "56px 0px 0px 70px",
  },
  limitedOfferContainer: {
    width: "100%",
    height: "16px",
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
    alignItems: "center",
    display: "flex",
    marginTop: "10px",
  },
  limitedOfferText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "10px",
    margin: "0px 0px 0px 62px",
    lineHeight: "12px",
    paddingLeft: "8px",
  },
  buttonTitle: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#FFFFFF",
    textTransform: "none",
  },
  signupErrorContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  firstOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "rgba(0, 0, 0, 0.9)",
    position: "relative",
    borderRadius: "8px",
  },
  secondOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "#D4403A",
    border: "1px solid #E1CAF2",
    position: "relative",
    borderRadius: "8px",
  },
  secondLogo: {
    width: "23px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "6px 5px 6px 5px",
  },
  thirdOfferContainer: {
    width: "34px",
    height: "34px",
    background: "url(/images/icons/matic.png)",
    position: "relative",
    borderRadius: "8px",
  },
  boxContainer: {
    position: "relative",
    maxWidth: "812px",
    width: "100%",
    height: "auto",
    padding: "20px",
    background: "#FFF",
    borderRadius: "20px",
    color: "white",
    boxShadow: 24,
    p: 4,
    padding: "0",
    margin: "auto",
  },
};

const JoinEarlyAccess = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpen1 = () => setOpen(true);
  const handleClose1 = () => setOpen(false);

  const [show, setShow] = useState(props.open);
  const [email, setEmail] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [location, setLocation] = useState("");

  useEffect(() => {
    getUserLocation();
  }, []);

  const handleClose = () => {
    setEmail("");
    setFormErrors({});
    setIsJoinedWaitList(false);
  };

  const [isJoinedWaitList, setIsJoinedWaitList] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [refLink, setRefLink] = useState(null);
  const [signupError, setSignupError] = useState("");
  const [copied, setCopied] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validateform = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email id is required!";
      setFormErrors(errors);
      return false;
    } else {
      if (!validateEmail(email)) {
        errors.email = "Please enter valid email id!";
        setFormErrors(errors);
        return false;
      }
    }
    return true;
  };

  const { mutate: getUserLocation } = useMutation(
    () => fetcher.get(GEOLOCATION_URL),
    {
      onSuccess: (result) => {
        setLocation(result);
      },
      onError: (error) => {
        setLocation({});
      },
    }
  );

  // re-send verify email
  const [resentEmail, setResentEmail] = useState(false);

  const { mutate: resendVerifyEmail } = useMutation(
    (userId) =>
      fetcher.post(`/v1/auth/send-verification-email`, {
        userId,
      }),

    {
      onSuccess: (res) => {
        setResentEmail(true);
        setTimeout(() => {
          setResentEmail(false);
        }, 2 * 60 * 1000);
      },
      onError: (error) => {
        setResentEmail(false);
      },
    }
  );

  const joinWaitList = async (token) => {
    setSignupError("");
    let userObject = {
      name: "Guest User",
      email: email,
      role: "user",
      token: token,
      location: location,
    };
    let userInviteCode = localStorage.getItem("inviteCode");
    if (userInviteCode && userInviteCode.length == 6) {
      userObject.referralCode = userInviteCode;
    }

    let response = await fetch(`${API_BASE_URL}/v1/user/early-signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userObject),
    });

    if (response.status == 201) {
      let data = await response.json();
      setIsJoinedWaitList(true);
      setRefLink(`${WEB_URL}/invite/?ic=${data.referralId.refCode}`);
      setUserDetails(data);
    } else {
      if (response.status == 409) {
        let data = await response.json();
        setIsJoinedWaitList(true);
        setRefLink(`${WEB_URL}/invite/?ic=${data.referralId.refCode}`);
        setUserDetails(data);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (email == "") {
      setFormErrors("Please enter valid email id");
    }
    if (validateform()) {
      joinWaitList(token);
    }
  };

  const onCaptchaChange = (value) => {};

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(refLink);
    setCopied(true);
  };
  return (
    <Box id="JoinEarlyAccess" sx={accessStyle.joinAccessSection}>
      {isJoinedWaitList ? (
        <div style={{ width: "100%", height: "100%" }}>
          {userDetails && (
            <Box sx={styles.boxContainer} style={{ width: "100%" }}>
              <Box
                sx={styles.modalCloseButton}
                onClick={handleClose}
                position="absolute"
              >
                <MdOutlineClose size={24} color="#000000" />
              </Box>

              <Box sx={styles.rankContainer}>
                <div style={styles.rankContainerInside}>
                  <Typography
                    sx={{
                      ...styles.rankHeadingText,
                      marginLeft: userDetails.isEmailVerified ? "24px" : "45px",
                    }}
                  >
                    {userDetails.isEmailVerified ? "Current Rank" : "Waitlist"}
                  </Typography>
                  <Typography
                    sx={{
                      ...styles.rankText,
                      fontSize:
                        userDetails?.rank?.toString()?.length > 4
                          ? "30px"
                          : "36px",
                      linHeight: "44px",
                    }}
                  >
                    {userDetails ? userDetails?.rank : ""}
                  </Typography>
                </div>
              </Box>

              <Box sx={{ ...styles.waitListDescription }}>
                <Typography sx={styles.waitListText}>
                  {userDetails.isEmailVerified
                    ? "Refer more to move up the Leaderboard!"
                    : "Verify your email and Refer!"}
                </Typography>

                <Typography
                  sx={{
                    ...styles.waitListText,
                    fontWeight: "400",
                    marginTop: "10px",
                  }}
                >
                  {userDetails.isEmailVerified
                    ? ""
                    : `We have sent a verification mail to ${userDetails.email}`}
                </Typography>

                {!userDetails.isEmailVerified && !resentEmail && (
                  <Box
                    onClick={() => {
                      resendVerifyEmail(userDetails.id);
                    }}
                  >
                    <Typography
                      sx={{
                        ...styles.waitListText,
                        fontWeight: "400",
                        marginTop: "10px",
                        color: "blue",
                        cursor: "pointer",
                      }}
                    >
                      Resend verification email
                    </Typography>
                  </Box>
                )}

                <>
                  {userDetails.isEmailVerified ? (
                    <Typography
                      sx={{
                        ...styles.waitListText,
                        fontWeight: "400",
                        marginTop: "10px",
                      }}
                    >
                      Good going, you are on a Roar. Refer more friends / family
                      by sharing below link to move up the leaderboard to win a{" "}
                      <b>FREE </b>Limited Edition <b>FanTiger NFT</b> and a{" "}
                      <b>surprise gift</b>.
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        ...styles.waitListText,
                        fontWeight: "400",
                        marginTop: "10px",
                      }}
                    >
                      Share the link below to <b>refer your friends / family</b>{" "}
                      to join. Every time your referral joins, you will move up
                      the leaderboard to win <b>FREE</b> Limited Edition
                      FanTiger NFT.
                    </Typography>
                  )}
                </>
              </Box>
              <Box
                sx={{ ...styles.urlContainer, cursor: "pointer" }}
                onClick={copyToClipboard}
              >
                <Typography
                  sx={{
                    width: "100%",
                    minWidth: "205px",
                    overflow: "hidden",
                    color: "#E14084",
                    whiteSpace: "nowrap",
                  }}
                >
                  {refLink}
                </Typography>

                {/* <a
                  href={refLink}
                  style={{
                    width: "100%",
                    minWidth: "205px",
                    overflow: "hidden",
                    color: "#E14084",
                    whiteSpace: "nowrap",
                  }}
                >
                  {refLink}
                </a> */}
                <Box sx={styles.copyToClipboardContainer}>
                  <Box sx={styles.copyToClipboardButton}>
                    {copied ? (
                      <Typography variant="h5" sx={styles.copied}>
                        Copied
                      </Typography>
                    ) : (
                      <IoCopyOutline size={24} color="#E14084" />
                    )}
                  </Box>
                </Box>
              </Box>
              <Box sx={styles.dashline}></Box>
              <Box sx={styles.socialButtonsContainer}>
                <Typography
                  sx={{
                    ...styles.waitListText,
                    fontWeight: "600",
                    fontSize: "18px",
                    marginBottom: "15px",
                    lineHeight: "27px",
                    color: "rgba(0, 0, 0, 0.75)",
                    textAlign: "center",
                  }}
                >
                  Share Now
                </Typography>
                <SocialShareComponent shareLink={refLink} />
              </Box>
              <Box
                sx={{
                  position: "relative",
                  margin: "15px auto 0",
                  width: "100%",
                  maxWidth: "675px",
                  height: "42px",
                }}
              >
                <Typography variant="h5" sx={styles.bottomText}>
                  For more updates, contests and giveaways, join our Community
                  on
                  <Link href="https://discord.gg/4asYZXT7FD" target="_blank">
                    {" "}
                    Discord.
                  </Link>
                </Typography>
              </Box>
            </Box>
          )}
        </div>
      ) : (
        <div className={styles.dataContainer}>
          <div className="title01 mx-auto d-block">
            <Box
              variant="h5"
              sx={accessStyle.mainTitle}
              id="exampleModalLongTitle"
            >
              Join Early Access Waitlist
            </Box>
          </div>
          <div className="join-waitlist-img">
            <Typography variant="h3" sx={accessStyle.limitedEdition}>
              Sign Up and Refer to get a FREE Limited Edition
            </Typography>
            <Typography variant="h2" sx={accessStyle.fantigerNFT}>
              FanTiger NFT
            </Typography>
            <Typography variant="h4" sx={accessStyle.limitedEdition1}>
              *Early access program valid for limited time period only. Why
              Wait, Join Now!
            </Typography>
          </div>
          <form onSubmit={handleSubmit} noValidate autoComplete="off">
            <div className="join-wait-form">
              <Box sx={accessStyle.inputContainer}>
                <Typography component="p" sx={accessStyle.inviters}>
                  Top 5,000 users with the highest Referrals will get a Free
                  Limited Edition FanTiger NFT. Sign-Up now and get your
                  referral link.&nbsp;
                  <Typography
                    variant="span"
                    onClick={handleOpen1}
                    style={{
                      color: "#e04084",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    How It Works?
                  </Typography>
                </Typography>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    style={{
                      background: "transparent",
                      border: "1px solid #fff",
                      color: "#fff",
                      boxShadow: "none",
                      "-webkit-input-placeholder": {
                        color: "#fff",
                      },
                    }}
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter your email Id*"
                    value={email}
                    onChange={(e) => {
                      setSignupError("");
                      setFormErrors({});
                      setEmail(e.target.value);
                    }}
                    name="email"
                  />
                  <div
                    style={{
                      overflow: "hidden",
                      fontWeight: "500",
                    }}
                  >
                    {formErrors?.email && (
                      <span style={{ color: "red" }}>{formErrors.email}</span>
                    )}
                    {signupError && (
                      <span style={{ color: "red" }}>{signupError}</span>
                    )}
                  </div>
                </div>
              </Box>

              <div className="form-group mx-auto d-block">
                <Typography component="p" sx={accessStyle.termCondition}>
                  By signing up, you agree to the{" "}
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => window.open("/terms", "_blank")}
                  >
                    T&C
                  </span>{" "}
                  and{" "}
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => window.open("/privacy", "_blank")}
                  >
                    Privacy
                  </span>{" "}
                  and to receive updates from FanTiger.
                </Typography>{" "}
              </div>
              <Button type="submit" style={{maxWidth:"360px",margin:"auto"}} sx={accessStyle.featuredBuyNow}>
                Join Waitlist / Check Rank
              </Button>
            </div>
          </form>
        </div>
      )}
      <Modal
        open={open}
        onClose={handleClose1}
        aria-labelledby="How It Works"
        aria-describedby="modal-modal-description"
      >
        <Box sx={accessStyle.modalContainer}>
          <Box sx={accessStyle.modalHeader}>
            <Typography variant="h4" sx={accessStyle.modalTitle}>
              How Early Access Works
            </Typography>
            <Typography
              variant="span"
              style={{ color: "#e04084", cursor: "pointer" }}
              onClick={handleClose1}
            >
              <i className="fa fa-times"></i>
            </Typography>
          </Box>
          <Box sx={accessStyle.modalBody}>
            <List sx={accessStyle.modalListContent} component="ol">
              <ListItem>
                <Box component="p">
                  FanTiger has launched ‘Early Access’ program for limited time
                  period where top 5,000 users who do the maximum number of
                  referrals will be eligible to win Free limited edition
                  FanTiger NFT. Few Top users might also be eligible to win
                  super exclusive FanTiger Platinum NFT. For the benefits of
                  FanTiger NFT, check our FAQ section. More details about
                  Platinum NFTs will be shared soon.
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                  Users will be ranked according to number of successful
                  referrals they will do. The more the referrals who sign up
                  using their invite link, the higher they will move up the
                  leaderboard and get a chance to grab a Limited Edition FanTiger
                  NFT. Users will get their referral invite link after doing
                  signup.
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                  Users will be able to check their current rank by entering
                  their email id on ‘Join Waitlist / Check Rank’ icon on
                  home page. After each successful referral, current rank will
                  change and can be checked here.
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                  Only verified users (users who will verify their email id)
                  will be eligible to grab Limited Edition FanTiger NFT.
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                  Only those referral users who will verify their email id will
                  be counted as successful referrals.{" "}
                </Box>
              </ListItem>
              <ListItem>
                <Box component="p">
                  Final decision on allotment of FanTiger NFTs will be at the
                  discretion of FanTiger management.
                </Box>
              </ListItem>
            </List>
          </Box>
          <Box sx={accessStyle.modalFooter}></Box>
        </Box>
      </Modal>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onCaptchaChange}
      />
    </Box>
  );
};

export default JoinEarlyAccess;
